import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private currentTheme: string;

  constructor() {
    this.currentTheme = environment.appFlavor;
    this.setTheme(this.currentTheme);
  }

  setTheme(theme: string) {
    // Remove any existing theme
    document.documentElement.removeAttribute('data-theme');
    // Set new theme
    document.documentElement.setAttribute('data-theme', theme);
    this.currentTheme = theme;
  }

  getCurrentTheme(): string {
    return this.currentTheme;
  }
}
